import { Wordmark } from '~/components'
import { Stack } from '~/components-v2'

export const TradeOffsCircles = () => {
  return (
    <div className="trade-offs">
      <div className="trade-off-lists">
        <div className="flexible">
          <Stack gap={2}>
            <h4>Flexible</h4>
            <ul>
              <li>Fast time-to-value</li>
              <li>Simple ad hoc analysis</li>
              <li>Easy data integrations</li>
              <li>Democratized access</li>
            </ul>
          </Stack>
        </div>
        <span>
          <Wordmark />
        </span>
        <div className="governed">
          <Stack gap={2}>
            <h4>Governed</h4>
            <ul>
              <li>Reliable, curated metrics</li>
              <li>Clear permissions</li>
              <li>Centralized management</li>
              <li>Operational workflows</li>
            </ul>
          </Stack>
        </div>
      </div>
    </div>
  )
}
